import React, { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useCoinPackages } from "../../../hooks/api/useWallet";
import BuyCoinsGrid from "../../Wallet/BuyCoinsGrid";
import BuyCoinsPaymentModal from "../../Wallet/modals/BuyCoinsPaymentModal";
import ModalWrapper from "../../ModalWrapper";

export default function CoinModal({ open, onClose }) {
  const { data: coinPackages, isLoading, isError, refetch } = useCoinPackages();
  const [selectedOffer, setSelectedOffer] = useState(null);

  const offers = (coinPackages || []).map((pkg) => ({
    coinPackageId: pkg.coinPackageId,
    revenueCatProductId: pkg.revenueCatProductId,
    name: pkg.name,
    coins: pkg.amount,
    price: `$${Number(pkg.price).toFixed(2)}`,
    description: pkg.description,
  }));

  if (!open) return null;

  return (
    <>
      <ModalWrapper
        className="max-w-[min(90vw,1170px)] p-4 md:p-6"
        onClose={onClose}
        disableHeaderBorder
        animationType="slide-up"
        zIndex="50"
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-4 sticky top-0 bg-[#353530] pb-2 md:pb-0 z-10">
          <h2 className="text-xl md:text-3xl font-bold">Recharge</h2>
          <button
            onClick={onClose}
            className="text-gray-300 hover:text-white text-2xl w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10"
          >
            ×
          </button>
        </div>

        {isLoading && (
          <p className="text-gray-400 text-sm text-center py-6">Loading coin packages...</p>
        )}

        {isError && (
          <div className="text-center py-6">
            <p className="text-red-400 text-sm mb-2">Unable to load coin packages.</p>
            <button onClick={() => refetch()} className="text-[#c9a227] text-sm hover:underline">
              Try again
            </button>
          </div>
        )}

        {!isLoading && !isError && (
          <div className="max-h-[60vh] md:max-h-none overflow-y-auto md:overflow-visible pb-2">
            <BuyCoinsGrid offers={offers} onSelect={setSelectedOffer} />
          </div>
        )}
      </ModalWrapper>
      {/* <div
        className={`
            pointer-events-auto
            animate-slideUp
            bg-[#353530]
            w-full md:w-[1170px]
            max-h-[90vh] md:max-h-none
            overflow-y-auto md:overflow-visible
            p-4 md:p-6
            shadow-xl
            mb-0 md:mb-20
            rounded-t-xl md:rounded-xl
          `}
      >

      </div > */}

      <AnimatePresence>
        {selectedOffer && (
          <BuyCoinsPaymentModal
            offer={selectedOffer}
            onClose={() => setSelectedOffer(null)}
          />
        )}
      </AnimatePresence>
    </>
  );
}
